<template>
  <div class="index">
    <!-- 法律咨询表单 -->
    <div class="consultBox">
      <p class="consultTitle">法律咨询</p>
      <div class="consultform">
        <div class="consultCenter">
          <el-form ref="consultForm" :model="consultForm" :rules="rules" label-width="80px">
            <el-form-item label="咨询标题">
              <el-input v-model="consultForm.title" placeholder="请输入标题,字数在50字以内"></el-input>
            </el-form-item>
            <el-form-item label="咨询内容">
              <el-input type="textarea" :rows="4" placeholder="请输入咨询内容,字数在1000字以内" v-model="consultForm.content"></el-input>
            </el-form-item>
            <el-form-item label="所在地区">
              <div class="areaBox">
                <el-select v-model="placeData[0]" clearable @change="remoteMethod($event, 1)" placeholder="省">
                  <el-option v-for="o in province" :key="o.id" :label="o.name" :value="o.id"></el-option>
                </el-select>
                <el-select v-model="placeData[1]" clearable @change="remoteMethod($event, 2)" placeholder="市">
                  <el-option v-for="o in city" :key="o.id" :label="o.name" :value="o.id"></el-option>
                </el-select>
                <el-select v-model="placeData[2]" clearable @change="remoteMethod($event, 3)" placeholder="县">
                  <el-option v-for="o in county" :key="o.id" :label="o.name" :value="o.id"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="手机号码" prop="phoneNumber">
              <el-input v-model="consultForm.phoneNumber" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="验证码">
              <el-input class="codeinput" v-model="consultForm.phoneCode" width="300px"></el-input>
              <el-button style="margin-left:30px" type="info" :disabled="sendCodeBtnSet.disabled" @click="sendCode()">{{sendCodeBtnSet.str}}</el-button>
            </el-form-item>
            <div class="subBox"><el-button type="danger" @click="submit()">提交咨询</el-button> </div>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 数据列表 -->
    <div class="dataBox">
      <ul class="dataUl" v-if="isShowList">
        <li class="datalist" v-for="(item,i) in tableData" :key="i" @click="clickListData(item)">
          <img class="imgbox" :src="headImgSrc" />
          <div class="textcont">
            <p class="title">{{item.title}}</p>
            <p class="info">
              <span>发布时间：{{item.createTime}}</span>
              <!-- <span>评论：0</span> -->
              <span>所在地区：{{item.province||'未填'}}-{{item.city||'未填'}}-{{item.county||'未填'}}</span>
            </p>
          </div>
        </li>
      </ul>
      <div class="detailbox" v-else>
        <p class="backBtn" @click="isShowList=true,detailData={}">← 返回列表</p>
        <p class="title">{{detailData.title}}</p>
        <p class="time">{{detailData.createTime}}</p>
        <p class="content">{{detailData.content}}</p>
        <p class="content" v-if="detailData.feedback&&detailData.feedback[0]">回复内容：{{detailData.feedback[0]}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import mixin_area from '@/Mixins/mixin_area'
export default {
  mixins: [ mixin_area ],
  props: ['tableData'],
  data() {
    let isPhone = (rule,value,callback)=>{
      let reg=/^1[3|4|5|7|8][0-9]\d{8}$/
      if (!reg.test(value)) {
        callback(new Error('手机号码不符合规范'))
      } else {
        callback()
      }
    };
    return {
      rules: { // 验证表单规则
        phoneNumber: [
          { required: 'true', message: '手机号不能为空', trigger: 'blur' },
          { validator: isPhone,trigger:'blur'}
        ],
      },
      consultForm: {}, // 表单对象
      province: [], // 表单里面的 省市县 的下拉框选项
      city: [],
      county: [],
      placeData: [], // 每个下拉框的areaId
      sendCodeBtnSet: {
        codeTime: 180,
        disabled: false,
        str: '获取验证码'
      }, // 发送验证码按钮的设置
      headImgSrc: require('@/assets/user-head-man.jpg'), // 列表里面的默认头像

      isShowList: true,
      detailData: {},
    }
  },
  computed: {
    provinceId() {
      return this.placeData[0]
    },
    cityId() {
      return this.placeData[1]
    }
  },
  methods: {
    //  获取位置
    areaGet(data) {
      console.log('获取位置')
      this.$api.getPlace(data.value).then(res => {
        if (res.data.status === 0 ) {
          let response = JSON.parse(res.data.data)
          switch(data.key) {
            case 0 : this.province = response;this.city = [];this.county = []; break
            case 1 : this.city = response;this.county = []; break
            case 2 : this.county = response; break
          }
        } else{
          this._status(res.data)
        }
      })
    },
    //  清空下级
    remoteMethod(value, num) {
      switch(num) {
        case 1: this.placeData[1] = this.placeData[2] = ''; break;
        case 2: this.placeData[2]= ''; break;
        case 3: break;
      }
    },
    //  发送验证码
    sendCode() {
      let vm = this;
      let phone = vm.consultForm.phoneNumber
      const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
      if (reg.test(phone)) {
        vm.sendCodeBtnSet.disabled = true; // 输入的号码格式正确，按钮变为不可点
        this.$api._user_SendCode({phone:phone}).then(res => {
          if (res.data.status == 0) {
             // 前端页面效果
            let time = setInterval(function() {
              vm.sendCodeBtnSet.codeTime--
              vm.sendCodeBtnSet.str = '('+vm.sendCodeBtnSet.codeTime+')'+'秒后可重发'
              if (vm.sendCodeBtnSet.codeTime <= 0 ) {
                clearInterval(time)
                vm.sendCodeBtnSet.str = '获取验证码'
                vm.sendCodeBtnSet.disabled = false;
                vm.sendCodeBtnSet.codeTime = 180
              }
            },1000);
          } else {
            this._status(res.data)
          }
        })
      } else {
        this.$message.info('请输入正确的手机号码')
      }
    },
    //  提交表单
    submit() {
      let vm = this
      this.$refs['consultForm'].validate((valid)=>{
        if (valid) { // 验证通过
          let areaIdArr = this.placeData.filter(function(o) { return o.areaId != '' })
          this.consultForm.areaId = areaIdArr[areaIdArr.length-1]
          let str = this.$api.imgUrl+'/law/service/'+this.consultForm.phoneCode
          vm.$api.create(str,this.consultForm).then(res => {
            if (res.data.status == 0) {
              this.$message.success('提交成功!')
              this.consultForm={}
              this.placeData = [ {areaId:''}, {areaId:''}, {areaId:''}]
              this.$parent.getrequestData();
            } else {
              this._status(res.data)
            }
          })
        } else {
          return false
        }
      })
    },
    //  点击数据
    clickListData(item) {
      console.log(item)
      this.isShowList = false
      this.detailData = item
    }
  },
  watch: {
    provinceId(val) {
      if (val == '') {
        this.areaGet({ value: { areaId: 0 }, key: 0 })
      } else {
        this.areaGet({ value: { areaId: val }, key: 1 })
      }
    },
    cityId(val) {
      let areaId = this.placeData[0]
      if (val == '') {
        this.areaGet({ value: { areaId: areaId }, key: 1 })
      } else {
        this.areaGet({ value: { areaId: val }, key: 2 })
      }
    }
  },
  created() {
    this.areaGet({ value: { areaId: 0 }, key: 0 })
  },
}
</script>

<style lang='scss' scoped>
/deep/.codeinput{width: 150px;}


.consultBox{width: 100%;border: 1px solid #eee;}
.consultBox .consultTitle:after{content: '';position: absolute;left: 10px;top: 14px;width: 3px;height: 24px;background-color: #ec0001;}
.consultBox .consultTitle{position: relative;padding-left: 20px;font-size: 18px;color: #333333;line-height: 50px;border-bottom: 1px solid #eee;}
.consultBox .consultform{padding: 15px;}
.consultBox .consultform input{height: 38px;}
.consultBox .consultform .consultCenter{padding: 20px 0px;width: 700px;margin: 0px auto;}
.consultBox .consultform .consultCenter .areaBox{display: flex;justify-content: space-between;}
.consultBox .consultform .consultCenter .areaBox div{width: 90%;}
.consultBox .consultform .consultCenter .subBox{padding: 20px 0px;}
.consultBox .consultform .consultCenter .subBox button{display: block;margin: 0px auto;}
.dataBox{width: 100%;margin-top: 15px;border: 1px solid #eee;}
.dataBox .datalist:hover{cursor: pointer;box-shadow: 0px 0px 20px #cccccc;}
.dataBox .datalist :hover .title{color: #1E9FFF;}
.dataBox .datalist{display: flex;height: 80px;padding: 15px;border-bottom: 1px solid #eeeeee;transition: all .2s;}
.dataBox .datalist .imgbox{display: block;margin-right: 15px;width: 80px;height: 80px;}
.dataBox .datalist .textcont{height: 80px;max-width: 830PX;flex: 1;}
.dataBox .datalist .textcont .title{width: 100%;line-height: 50px;font-size: 22px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-bottom: 10PX;}
.dataBox .datalist .textcont .info{line-height: 20PX;font-size: 14px;}
.dataBox .datalist .textcont .info span{display: inline-block;}
.dataBox .datalist .textcont .info span:nth-child(2){margin: 0px 30px;}



.detailbox{
  min-height: 600px;
  .backBtn{width: 120px;height: 60px;line-height: 60px;padding: 10px;cursor: pointer;}
  .backBtn:hover{color:#1E9FFF;}
  .title{text-align: center;font-size: 32px;padding: 20px;}
  .time{text-align: center;}
  .content{padding: 40px;line-height: 24px;}
}
</style>